/**
 * Redwood DS specific global CSS.
 **/
import { css } from "@oui/system"

const baseFontSize = 16
// todo fill in redwood values for Hg placeholders
const borderColor = "#b5bbc2"

const global = css`
  html {
    box-sizing: border-box;
    color: #222; /* TODO: grab color from theme */
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: ${baseFontSize}px;
    font-weight: normal;
    height: 100%;
    line-height: 1.428;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }
  body {
    height: 100%;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`

export { baseFontSize, borderColor }
export default global
